"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AJsonStruct = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const constants_1 = __importDefault(require("../../constants"));
const utils_1 = require("../../utils");
const { SUB_TYPE, TYPE, METADATA_DEFAULTS } = constants_1.default;
// const META_DEF: IAJsonMetaData = { version: METADATA_DEFAULTS.VERSION, dpi: METADATA_DEFAULTS.DPI };
class AJsonStruct {
    constructor({ templateIdGenerator, fieldIds = [], version = METADATA_DEFAULTS.VERSION, dpi = METADATA_DEFAULTS.DPI, generateLayers = {}, isAnonymizeDoc = false, }) {
        this._dpi = METADATA_DEFAULTS.DPI;
        this._version = METADATA_DEFAULTS.VERSION;
        this._isAnonymizeDoc = false;
        this._version = version;
        this._dpi = dpi;
        this._maxFieldOrder = 0;
        this._fieldIds = fieldIds;
        this._doc = {};
        this._docAnonymized = {};
        if (generateLayers.content) {
            this._doc.content = { metadata: this._getMeta(), list: [] };
            if (isAnonymizeDoc)
                this._docAnonymized.content = { metadata: this._getMeta(), list: [] };
        }
        if (generateLayers.fields) {
            this._doc.fields = { metadata: this._getMeta(), list: [] };
            if (isAnonymizeDoc)
                this._docAnonymized.fields = { metadata: this._getMeta(), list: [] };
        }
        if (generateLayers.comments) {
            this._doc.comments = { metadata: this._getMeta(), list: [] };
            if (isAnonymizeDoc)
                this._docAnonymized.comments = { metadata: this._getMeta(), list: [] };
        }
        if (generateLayers.roles) {
            this._doc.roles = { metadata: this._getMeta(), list: [] };
            if (isAnonymizeDoc)
                this._docAnonymized.roles = { metadata: this._getMeta(), list: [] };
        }
        if (generateLayers.attributes) {
            this._doc.attributes = { metadata: this._getMeta(), list: {} };
            if (isAnonymizeDoc)
                this._docAnonymized.attributes = { metadata: this._getMeta(), list: {} };
        }
        this._isAnonymizeDoc = isAnonymizeDoc;
        if (typeof templateIdGenerator === 'function')
            this._templateIdGenerator = templateIdGenerator;
    }
    addPages(pages) {
        this._doc.pages = this._genMetadataStruct(pages);
        if (this._isAnonymizeDoc)
            this._docAnonymized.pages = this._genMetadataStruct(pages);
    }
    addAttribute(operationProps) {
        const SECTION_ATTRIBUTES = 'attributes';
        if (!lodash_1.default.get(operationProps, 'subType', false) || !lodash_1.default.get(operationProps, 'content', false))
            return;
        if (!this._doc[SECTION_ATTRIBUTES])
            this._doc[SECTION_ATTRIBUTES] = this._genMetadataStruct({});
        this._doc[SECTION_ATTRIBUTES].list[operationProps.subType] = {
            content: operationProps.content,
        };
        if (this._isAnonymizeDoc)
            this._docAnonymized.attributes = this._doc.attributes;
    }
    addComment(operationProps) {
        const SECTION_NAME = 'comments';
        const { content: operationContent, pageId } = operationProps;
        if (!operationContent)
            return;
        const { 
        // author, date, message, owner, replies, resolved, width, height, x, y,
        author, date, message, owner, replies } = operationContent, general = __rest(operationContent, ["author", "date", "message", "owner", "replies"]);
        const comment = Object.assign({ author,
            date,
            message,
            owner,
            general }, (Array.isArray(replies) && replies.length ? { replies } : {}));
        try {
            if (!this._doc[SECTION_NAME])
                this._doc[SECTION_NAME] = this._genMetadataStruct([]);
            const section = this._doc[SECTION_NAME];
            utils_1.addToPage(section, comment, { pageId });
            if (this._isAnonymizeDoc) {
                if (!this._docAnonymized[SECTION_NAME])
                    this._docAnonymized[SECTION_NAME] = this._genMetadataStruct([]);
                const sectionAnonym = this._docAnonymized[SECTION_NAME];
                utils_1.addToPage(sectionAnonym, utils_1.anonymizeComment(comment), { pageId });
            }
        }
        catch (err) {
            throw new Error(`Failed add to comment[${pageId}] :: ${JSON.stringify(operationProps)}`);
        }
    }
    addTemplate(operationProps) {
        const SECTION_NAME = 'fields';
        const { type, subType, template, pageId } = operationProps;
        const { type: fieldType, subType: fieldSubType } = template;
        let isTemplateItemChanged = false;
        // control order
        if (!template.order) {
            this._maxFieldOrder++;
            template.order = this._maxFieldOrder;
            isTemplateItemChanged = true;
        }
        else if (template.order === this._maxFieldOrder) {
            template.order++;
            this._maxFieldOrder = template.order;
        }
        else {
            this._maxFieldOrder = Math.max(this._maxFieldOrder, template.order);
        }
        // control ID
        switch (typeof template.id) {
            case 'string':
                break;
            case 'number':
                template.id = template.id.toString();
                isTemplateItemChanged = true;
                break;
            default: {
                const id = this._genTemplateId();
                if (id) {
                    template.id = id;
                    this._fieldIds.push(id);
                    isTemplateItemChanged = true;
                }
            }
        }
        const templateFull = Object.assign(Object.assign({}, template), { type: fieldType || type, subType: fieldSubType || subType, pageId });
        try {
            if (!this._doc[SECTION_NAME])
                this._doc[SECTION_NAME] = this._genMetadataStruct([]);
            const section = this._doc[SECTION_NAME];
            utils_1.addToPage(section, templateFull, { pageId });
            if (this._isAnonymizeDoc) {
                if (!this._docAnonymized[SECTION_NAME])
                    this._docAnonymized[SECTION_NAME] = this._genMetadataStruct([]);
                const sectionAnonym = this._docAnonymized[SECTION_NAME];
                utils_1.addToPage(sectionAnonym, utils_1.anonymizeField(templateFull), { pageId });
            }
            return { isTemplateItemChanged };
        }
        catch (err) {
            throw new Error(`Failed add to fields to page ${pageId} :: ${JSON.stringify(templateFull)}`);
        }
    }
    addContent(operationProps) {
        const SECTION_NAME = 'content';
        const { content, pageId, template } = operationProps;
        if (lodash_1.default.isEmpty(content))
            return;
        if (template && template.id) {
            content.linkId = template.id;
        }
        const { contentType, contentSubType } = this._getContentIdentityByOperationProps(operationProps);
        const contentFull = Object.assign(Object.assign({}, content), { type: contentType, subType: contentSubType });
        try {
            if (!this._doc[SECTION_NAME])
                this._doc[SECTION_NAME] = this._genMetadataStruct([]);
            const section = this._doc[SECTION_NAME];
            utils_1.addToPage(section, contentFull, { pageId });
            if (this._isAnonymizeDoc) {
                if (!this._docAnonymized[SECTION_NAME])
                    this._docAnonymized[SECTION_NAME] = this._genMetadataStruct([]);
                const sectionAnonym = this._docAnonymized[SECTION_NAME];
                utils_1.addToPage(sectionAnonym, utils_1.anonymizeContent(contentFull), { pageId });
            }
        }
        catch (err) {
            throw new Error(`Failed add ${SECTION_NAME}[${pageId}] ${JSON.stringify(contentFull)}`);
        }
    }
    addWarning(exception) {
        if (!this._doc.warnings) {
            this._doc.warnings = { list: [] };
        }
        this._doc.warnings.list.push(exception.message);
        if (this._isAnonymizeDoc)
            this._docAnonymized.warnings = this._doc.warnings;
    }
    toJson() {
        return this._doc;
    }
    getAnonymized() {
        return this._docAnonymized;
    }
    _getContentIdentityByOperationProps(operationProps) {
        const { type, subType, content } = operationProps;
        const cntSubType = content.subType;
        const DEF_RES = {
            contentType: type,
            contentSubType: cntSubType || subType || SUB_TYPE.NONE,
        };
        switch (type) {
            case TYPE.CHECKMARK:
            case TYPE.RADIO: {
                return Object.assign(Object.assign({}, DEF_RES), { contentSubType: cntSubType || subType || 'x' });
            }
            default:
                return DEF_RES;
        }
    }
    _genMetadataStruct(list, metadata = {}) {
        return {
            metadata: Object.assign(Object.assign({}, this._getMeta()), metadata),
            list,
        };
    }
    _genTemplateId() {
        if (this._templateIdGenerator)
            return this._templateIdGenerator(this._fieldIds).toString();
        return uuid_1.v4();
    }
    _getMeta() {
        return {
            version: this._version || METADATA_DEFAULTS.VERSION,
            dpi: this._dpi || METADATA_DEFAULTS.DPI,
        };
    }
}
exports.AJsonStruct = AJsonStruct;
//# sourceMappingURL=AJsonStruct.js.map